import $ from "jquery"

export default {
  install(app, options) {
    /**
     * recalculate table width, rows height and add shadow if necessary
     * in componets only call this.$updateResponsiveTable(this); where should be table recalculated
     */
    app.config.globalProperties.$updateResponsiveTable = function (obj, id) {
      console.log("responsive table updateResponsiveTable")
      this.$updateTableContent(obj, id)
      this.$recalculateTableHeight(id)
      this.$checkTableWidth(obj, id)
    }
    /**
     * compute table width and add shadow
     */
    app.config.globalProperties.$checkTableWidth = function (obj, id) {
      console.log("responsive table checkTableWidth")
      const responsiveWidth = $("#" + id + ".table-responsive").width()
      const mainWidth = $("#" + id + " .table-main").width()
      //var firstWidth = $("#" + id + " .fixed-first-column").width();
      //var lastWidth = $("#" + id + " .fixed-last-column").width();

      //var visiblePart = responsiveWidth - (firstWidth + lastWidth);
      /*
      var columnWidth = 0;
      for (var i = 1; i < obj.columns.length - 1; i++) {
        columnWidth += parseInt(obj.columns[i].minWidth.replace("px", ""));
      }


      columnWidth += 140;
      */
      console.log("dimensions" + responsiveWidth + " <= " + mainWidth)

      if (mainWidth <= responsiveWidth) {
        $("#" + id + ".table-responsive").removeClass("shadowed")
        $("#" + id + " .fixed-first-column").removeClass("showShadow")
        $("#" + id + " .fixed-last-column").removeClass("showShadow")
      } else {
        $("#" + id + ".table-responsive").addClass("shadowed")
        $("#" + id + " .fixed-first-column").addClass("showShadow")
        $("#" + id + " .fixed-last-column").addClass("showShadow")
      }
    }
    app.config.globalProperties.$recalculateTableHeight = function (id) {
      console.log("responsive table recalculateTableHeight")
      const $table = $("#" + id + " .table-main")

      const $fixedFirstColumn = $("#" + id + " .fixed-first-column")
      const $fixedLastColumn = $("#" + id + " .fixed-last-column")

      /**
       * Keep the frozen first-column overlay the SAME width as the main table's
       * first column. With table-layout:fixed the column sits at its minWidth
       * only while the table overflows; on wide screens the spare width is
       * distributed so the real width is a few px larger. Feed the measured
       * width into --fixed-first-width so the seam stays aligned (no double
       * border, no overlap of the next column).
       */
      const mainFirstCell = $table.find("tbody tr:first > td:first-child").get(0)
      const overlayEl = $fixedFirstColumn.get(0)
      if (mainFirstCell && overlayEl) {
        const w = mainFirstCell.getBoundingClientRect().width
        if (w) {
          overlayEl.style.setProperty("--fixed-first-width", w + "px")
        }
      }

      $fixedFirstColumn.find("tr").each(function (i) {
        $(this).height($table.find("tr:eq(" + i + ")").height())
      })

      $fixedLastColumn.find("tr").each(function (i) {
        $(this).height($table.find("tr:eq(" + i + ")").height())
      })
    }
    app.config.globalProperties.$updateTableContent = function (obj, id) {
      obj.tableColumns = obj.getTableColumns()

      obj.columns.forEach((element) => {
        if ((element.type ?? element.name) in obj.tableColumns) {
          element.order = obj.tableColumns[element.type ?? element.name].order
          element.visible = obj.tableColumns[element.type ?? element.name].show
        }
      })

      obj.columns.sort(this.$compare)

      for (let i = 0; i < obj.columns.length; i++) {
        let val = parseInt(obj.columns[i].minWidth?.replace("px", "")) ?? 0
        /**
         * add some small space to the last column for showing sorting icon
         */
        if (i == obj.columns.length - 1) {
          $("#" + id + " .table-main td:nth-last-child(2)").css(
            "min-width",
            val + 30
          )
          val += 30
        }
        obj.tableWidth += val
      }
    }
    app.config.globalProperties.$compare = function (a, b) {
      if (a && b) {
        if (a.order < b.order) {
          return -1
        }
        if (a.order > b.order) {
          return 1
        }
      }

      return 0
    }
  },
}
